;(function () {
    function PageViewTracking(businessArea) {
        /**
         * local object availability
         * @type {PageViewTracking}
         * @private
         */
        var _this = this

        /**
         * Get the current pathname (e.g. the pathname of https://example.com/expl?abc=20 => /expl)
         * @type {string}
         * @private
         */
        this.getPathName = function () {
            return window.location.pathname
        }

        /**
         * Return the businessArea with a uppercase letter
         * @type {string}
         * @private
         */
        this.getUpperCaseBusinessArea = function () {
            return businessArea.charAt(0).toUpperCase() + businessArea.slice(1)
        }

        /**
         * Build the tracking data and push it to the GTM dataLayer
         *
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            var trackingData = {
                url_virtual: _this.getPathName(),
                pagetype: 'content',
                content_group: _this.getUpperCaseBusinessArea(),
                event: 'vPageview',
            }
            dataLayer.push(trackingData)
        }

        /**
         * initial call ("the constructor")
         */
        if (typeof dataLayer === 'object') {
            _this.init()
        }
    }

    window.Energy = window.Energy || {}
    window.Energy.PageViewTracking = PageViewTracking

    // fire event to signal that this script is loaded. The BusinessAreaSelector is dependent on this script to be available
    window.dispatchEvent(new Event('pageViewTrackingLoaded'))
})()
